import { useEffect, useRef, useState} from 'react';
import { useLocation } from 'react-router-dom';
import FadeIn from 'react-fade-in';
import piggyBank from './images/piggy-bank.png';
import handShake from './images/handshake copy.png';
import idea from './images/idea.png';
import websitePng from './images/website.png';
import designPng from './images/design.png';
import functionalityPng from './images/functionality.png';
import omateevJpg from './images/o_mateev.jpg';
import sstoitchkovaJpg from './images/s_stoitchkova.jpg';
import { lng } from './js/language.js';

function Services() {
    const sectionAboutUs = useRef(null);
    const sectionOrlin = useRef(null);
    const sectionStoianka = useRef(null);
    const location = useLocation();
    const {hash} = location;

    const [widthDisplay, setWidthDisplay] = useState(window.innerWidth);
    function handleWindowSizeChange() {
        setWidthDisplay(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);
    const isMobile = widthDisplay <= 768;

    const [isVisibleFadeIn, setIsVisibleFadeIn] = useState(isMobile ? true : false);
    const [isVisibleFadeInOrlin, setIsVisibleFadeInOrlin] = useState(isMobile ? true : false);
    const [isVisibleFadeInStoianka, setIsVisibleFadeInStoianka] = useState(isMobile ? true : false);

    const handleDistanceY = () => {
        setIsVisibleFadeIn(
            (sectionAboutUs.current.offsetTop - window.pageYOffset < 400 && sectionAboutUs.current.offsetTop - window.pageYOffset > -100) ||
            (window.pageYOffset - sectionAboutUs.current.offsetTop < 600 && window.pageYOffset - sectionAboutUs.current.offsetTop > -100) || isMobile
                ? true : false);
        setIsVisibleFadeInOrlin(
            (sectionOrlin.current.offsetTop - window.pageYOffset < 400 && sectionOrlin.current.offsetTop - window.pageYOffset > -100) ||
            (window.pageYOffset - sectionOrlin.current.offsetTop < 800 && window.pageYOffset - sectionOrlin.current.offsetTop > -100) || isMobile
                ? true : false);
        setIsVisibleFadeInStoianka(
            (sectionStoianka.current.offsetTop - window.pageYOffset < 400 && sectionStoianka.current.offsetTop - window.pageYOffset > -100) ||
            (window.pageYOffset - sectionStoianka.current.offsetTop < 800 && window.pageYOffset - sectionStoianka.current.offsetTop > -100) || isMobile
                ? true : false);      
    };

     useEffect(() => {
        if (hash === '#about-us') {      
            window.scrollTo({
                top: sectionAboutUs.current.offsetTop,
                behavior: "smooth",
            });
        }
        window.addEventListener('scroll', handleDistanceY);
        return () => {
            window.removeEventListener('scroll', handleDistanceY);
        };
    }, [hash, sectionAboutUs]);

    const [currentLangObj, setCurrentLangObj] = useState(lng[localStorage.getItem('currentLang') || 'bg']);
    function handleCheckLang() {
        setCurrentLangObj(lng[localStorage.getItem('currentLang') || 'bg']);
    }
    useEffect(() => {
        window.addEventListener('click', handleCheckLang);
        return () => {
            window.removeEventListener('click', handleCheckLang);
        };
    }, []);

  return (
    <section className="services" id="about-us" ref={sectionAboutUs}>
        <div className="container">
            <div className="title text-center">
                <h1 className="title-blue why-us">
                    {currentLangObj.whyUs}
                </h1>
            </div>
            <div className="container-services">
                <div className="row">
                    <div className="col-sm-6 col-lg-4 fade-in-out">
                        <FadeIn
                            delay = {200}
                            transitionDuration = {200}
                            visible = {isVisibleFadeIn}
                        >
                            <div className="media aos-init">
                                <img className="mr-4" src={piggyBank} alt="" />
                                <div className="media-body">
                                    <h5 className="why-1">{currentLangObj.why1}</h5>
                                    <span className="why-content-1">{currentLangObj.whyContent1}</span>
                                </div>
                            </div>
                        </FadeIn>
                    </div>
                    <div className="col-sm-6 col-lg-4">
                        <FadeIn
                            delay = {400}
                            transitionDuration = {200}
                            visible = {isVisibleFadeIn}
                        >
                            <div className="media aos-init">
                                <img className="mr-4" src={handShake} alt="" />
                                <div className="media-body">
                                    <h5 className="why-2">{currentLangObj.why2}</h5>
                                    <span className="why-content-2">{currentLangObj.whyContent2}</span>
                                </div>
                            </div>
                        </FadeIn>
                    </div>
                    <div className="col-sm-6 col-lg-4">
                        <FadeIn
                            delay = {600}
                            transitionDuration = {200}
                            visible = {isVisibleFadeIn}
                        >
                            <div className="media aos-init">
                                <img className="mr-4" src={idea} alt="" />
                                <div className="media-body">
                                    <h5 className="why-3">{currentLangObj.why3}</h5>
                                    <span className="why-content-3">{currentLangObj.whyContent3}</span>
                                </div>
                            </div>
                        </FadeIn>
                    </div>
                    <div className="col-sm-6 col-lg-4">
                        <FadeIn
                            delay = {800}
                            transitionDuration = {200}
                            visible = {isVisibleFadeIn}
                        >
                            <div className="media aos-init">
                                <img className="mr-4" src={websitePng} alt="" />
                                <div className="media-body">
                                    <h5 className="why-4">{currentLangObj.why4}</h5>
                                    <span className="why-content-4">{currentLangObj.whyContent4}</span>
                                </div>
                            </div>
                        </FadeIn>
                    </div>
                    <div className="col-sm-6 col-lg-4">
                        <FadeIn
                            delay = {1000}
                            transitionDuration = {200}
                            visible = {isVisibleFadeIn}
                        >
                            <div className="media aos-init">
                                <img className="mr-4" src={designPng} alt="" />
                                <div className="media-body">
                                    <h5 className="why-5">{currentLangObj.why5}</h5>
                                    <span className="why-content-5">{currentLangObj.whyContent5}</span>
                                </div>
                            </div>
                        </FadeIn>
                    </div>
                    <div className="col-sm-6 col-lg-4">
                        <FadeIn
                            delay = {1200}
                            transitionDuration = {200}
                            visible = {isVisibleFadeIn}
                        >
                            <div className="media aos-init">
                                <img className="mr-4" src={functionalityPng} alt="" />
                                <div className="media-body">
                                    <h5 className="why-6">{currentLangObj.why6}</h5>
                                    <span className="why-content-6">{currentLangObj.whyContent6}</span>
                                </div>
                            </div>
                        </FadeIn>

                    </div>
                </div>
            </div>
        </div>

        <div className="title text-center aos-init" ref={sectionOrlin}>
            <h1 className="title-blue">Почтеност и експертиза</h1>
        </div>
        <div className="container-services">
            <div className="row">
                <div className="col-sm-12 team aos-init">
                    <FadeIn
                        delay = {200}
                        transitionDuration = {200}
                        visible = {isVisibleFadeInOrlin}
                    >
                        <div className="team-info"><span>С над 20 години опит</span> в разработването на уеб базиран
                            софтуер.
                            С висше магистърско образование, специалност математика и инфоматика в Софийския
                            университет.
                        </div>
                        <div className="team-info">През годините съм работил както по самостоятелни проекти, така и като
                            част от големи екипи – опит, който ме научи на устойчивост, адаптивност и значението на
                            ясната комуникация.
                            Вярвам, че най-добрите решения са онези, които са едновременно ефективни, разбираеми и
                            създадени с грижа към клиента.
                        </div>
                        <div className="row team-section aos-init">
                            <div className="col-sm-6 col-lg-8 team">
                                <div className="team-info">
                                    <span>През 2024 г. Векота беше основана с ясна цел</span> – да
                                    създаваме стойностни дигитални продукти, които са полезни, достъпни и съобразени с
                                    реалните нужди на клиентите.
                                </div>
                                <div className="team-info">
                                    <span>Нашето конкурентно предимство е в подхода:</span>
                                </div>
                                <div className="team-info">
                                    <span>Прозрачност и информираност</span> – ние не налагаме скрити
                                    или ненужни абонаменти. За повечето проекти еднократната инвестиция в сайта е
                                    напълно достатъчна.</div>
                                <div className="team-info">
                                    <span>Функционалност и автономност</span> – осигуряваме удобни
                                    административни панели, чрез които клиентите могат сами да управляват сайта си.
                                </div>
                                <div className="team-info">
                                    <span>Индивидуален подход</span> – всеки клиент получава решение,
                                    изцяло съобразено с неговите нужди, с професионален съвет и коректно отношение.
                                </div>
                                <div className="team-info">
                                    Стремим да представяме всичко на <span>ясен и достъпен език</span>, да дадем възможност за <span>информиран избор</span> и
                                                        създадем усещане за сигурност.
                                </div>
                                <div className="team-info">
                                    <span>Човечност и грижа</span> – вярваме в устойчиви
                                    партньорства, изградени върху доверие, а не на агресивни търговски практики.
                                </div>
                                <div className="team-info">
                                    <span>Изградихме екип работещ в атмосфера на свобода и
                                        уважение</span> – с 4-дневна работна седмица, възможност за изцяло дистанционна
                                    работа и подкрепяща култура. Вярвам, че добрата среда води до добри резултати – и
                                    това личи в работата ни.
                                </div>
                                <div className="team-info">
                                    <span>Във Векота не правим просто уебсайтове.</span> Създаваме
                                    работещи решения, които носят стойност, сигурност и спокойствие на клиентите ни.
                                </div>
                            </div>
                            <div className="col-sm-6 col-lg-4">
                                <img className="mr-img" alt={currentLangObj.name1} width="100%" src={omateevJpg} />
                                <div className="team-info">
                                    <div className="team-title">
                                        <span className="name-1">{currentLangObj.name1}</span>,
                                        <div className="position-1">{currentLangObj.position1}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </FadeIn>
                </div>
            </div>
        </div>    
        <div className="col-sm-12 title text-center aos-init"  ref={sectionStoianka}>
            <h1 className="title-blue">Доверие и грижа за детайлите</h1>
        </div>
        <div className="container-services">
            <div className="row">
                <FadeIn
                    delay = {200}
                    transitionDuration = {200}
                    visible = {isVisibleFadeInStoianka}
                >
                    <div className="col-sm-12 team aos-init">
                        <div className="team-info">
                            <span>С над 3 години опит в планирането и реализирането</span> на
                            уеб базирани приложения с фокус върху 
                            <span>дизайн, маркетинг и потребителско преживяване</span>.
                        </div>
                    
                    <div className="row team-section aos-init">
                        <div className="col-sm-6 col-lg-8 team">
                            <div className="team-info"><span>Грижата за детайлите</span>, реализирането на
                                проектите за оптималното възможно време без компромис в качеството са наш
                                приоритет.
                            </div>
                            <div className="team-info">
                                <span>Вярвам, че ключът към успешен проект е в екипната
                                    синергия и ясната комуникация</span> – с екипа и с клиента. Работя с
                                внимание към детайла и постоянен стремеж към ефективност, като приоритет
                                винаги са качественият краен продукт и удовлетвореността на клиента.
                            </div>
                            <div className="team-info">
                                <span>Изграждането на доверие</span> се постига чрез
                                коректност и професионално отношение демонстрирано ежедневно към всеки един
                                детайл.
                                Постоянно се стремим да предлагаме все по-качествен продукт реализиран с
                                прецизност и отношение към специфичнитв потребности на нашите клиенти и
                                партньори.
                            </div>
                            <div className="team-info">
                                <span>Изработването на уникален дизайн</span> заедно с
                                функционалността на проекта е наше задължение. Разглеждаме и обсъждаме
                                обстойно всяко ново запитване и поръчка и предлагаме най-добрите решения
                                взимайки предвид всеки детайл.
                            </div>
                            <div className="team-info">
                                <span>Успешната маркетингова стратегия</span> и
                                оптимизацията са от изключителна важност за навременното позициониране и
                                разпознаваемост на всеки дигитален продукт.
                            </div>
                            <div className="team-info"> 
                                <span>Устойчивите партньорства, изградени върху доверие
                                    и резултати
                                </span>, са моят основен стимул да продължавам да се развивам
                                и да надграждам постигнатото.
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4">
                            <img className="mr-img" alt={currentLangObj.name1} width="100%" src={sstoitchkovaJpg} />
                            <div className="team-info">
                                <div className="team-title">
                                    <span className="name-2">{currentLangObj.name2}</span>,
                                    <div className="position-2">{currentLangObj.position2}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </FadeIn>
            </div>
        </div>
    </section>
  );
}

export default Services;
